export const deliveredProductsByBar = {
	tabTitle: "Productos entregados por bar",
	filename: "productos-entregados",
	selectedBars: "Bares seleccionados",
	noSelectedBar: "Seleccione al menos un bar para ver el informe",
	table: {
		total: "Total",
		name: "Nombre",
		count: "Unidades Vendidas",
		fracionalCount: "Cantidad Fraccionaria",
		fracCount: "Cantidad Frac.",
		unitCost: "Valor Unitario",
		proportionalValue: "Valor Proporcional",
		subtotal: "Subtotal",
		totalDiscount: "Descuentos",
		totalVat: "Total IVA",
		valueVat: "IVA",
		totalValue: "Valor Total",
		category: "Categoría",
	},
	bar: "Bar",
	selectPlaceholder: "Seleccione Bar(es)",
	all: "Todos",
	selectVisualization: "Seleccione visualización",
	byBars: "Por bares",
	transactionType: "Tipo de transacción",
	bars: "Bares",
	productMasterKinds: "Tipos de productos",
	applyFilters: "Aplicar filtros",
	total: "Total",
	emptyState: {
		withoutFilters: {
			title: "Sin filtros aplicados",
			description: "Seleccione al menos un bar para generar un informe.",
		},
		anyResults: {
			title: "Ningún resultado encontrado",
			description:
				"¡No fue posible encontrar resultados compatibles con los filtros aplicados!",
		},
	},
	totalizer: {
		totalUnitsSold: "Total de unidades vendidas",
		totalInDiscounts: "Total en descuentos",
		totalValueSold: "Valor total vendido",
	},
};
